import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function NotImplemented({ location }) {
  const { t } = useTranslation()

  return (
    <>
      <h2>{t('notImplemented.greeting', 'Not Implemented')}</h2>
      <div>
        {t('notImplemented.breadcrumb', 'You are here')}: {location && location.pathname}
      </div>
    </>
  )
}

NotImplemented.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired }),
}
